/// THIS FILE IS AUTOGENERATED!!! DO NOT EDIT MANUALLY!!!
/// INSTEAD, USE A VITE PLUGIN OR RUN `php artisan bridge:generate:features` COMMAND.

export const Features = {
  abandonedCarts: { isEnabled: true, isDisabled: false },
  affiliateMarketing: { isEnabled: true, isDisabled: false },
  baselinker: { isEnabled: false, isDisabled: true },
  blog: { isEnabled: true, isDisabled: false },
  combineDiscounts: { isEnabled: false, isDisabled: true },
  complaintsAndRefundsModule: { isEnabled: false, isDisabled: true },
  customersProductPrices: { isEnabled: false, isDisabled: true },
  forceAuthenticated: { isEnabled: false, isDisabled: true },
  forceAuthenticatedAndAccepted: { isEnabled: false, isDisabled: true },
  googleReviews: { isEnabled: true, isDisabled: false },
  hermes: { isEnabled: true, isDisabled: false },
  imoje: { isEnabled: true, isDisabled: false },
  loyaltyPoints: { isEnabled: true, isDisabled: false },
  medicalContractorsRegistry: { isEnabled: false, isDisabled: true },
  medicines: { isEnabled: true, isDisabled: false },
  newsletter: { isEnabled: true, isDisabled: false },
  offers: { isEnabled: true, isDisabled: false },
  orders: { isEnabled: true, isDisabled: false },
  ordersAlwaysProcessingStatus: { isEnabled: false, isDisabled: true },
  ordersByGuests: { isEnabled: false, isDisabled: true },
  ordersOverSupply: { isEnabled: false, isDisabled: true },
  ordersOverSupplyForBusinessOnly: { isEnabled: true, isDisabled: false },
  payu: { isEnabled: false, isDisabled: true },
  personal: { isEnabled: true, isDisabled: false },
  przelewy24: { isEnabled: true, isDisabled: false },
  pwa: { isEnabled: true, isDisabled: false },
  streamsoft: { isEnabled: false, isDisabled: true },
  streamsoftContractorPrices: { isEnabled: false, isDisabled: true },
  streamsoftExistingContractorsSync: { isEnabled: false, isDisabled: true },
  tradeCredit: { isEnabled: true, isDisabled: false },
} as const;